import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import { ScrollView } from '../../../../common/components/atoms';
import { HeaderTitle } from '../../../components/molecues';
import { getSplitedDivs, convISO8601 } from '../../../../common/helper/commonHelper.js'

import icon_up from '../../../components/atoms/data/icon_up.svg';
import icon_down from '../../../components/atoms/data/icon_down.svg';

class Notice extends Component {
    constructor(props) {
        super(props);
        this.refScroll = React.createRef();
        this.state = {
            current: 6,
            subjectList: [],
            noticeList: [],
            notice: {title: "", contents: ""},
            infoContentsDisplay: [],
        }
    }
    componentDidMount() {
		this.props.dispatch({
            type: "LoadEnd"
        });
        this.noticeReload();
    }
    noticeReload = () => {
        this.props.dispatch({
            type: "GetNoticeList_Saga",
            id: this.props.user.id,
            onSuccess: this.onSuccessGetNoticeList,
            onFailure: this.onFailure,
        });
    }
    onSuccessGetNoticeList = (list) => {
        this.setState({ noticeList: list });
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onClickInfo(e, index) {
        let notice = this.state.noticeList[index];
        if (notice.unread) {
            notice.unread = false;

            // お知らせ既読通知
            // お気に入り登録・解除と同様にサーバー返却を待たない方式とする
            this.props.dispatch({
                type: 'ReadNotice_Saga',
                noticeId: notice.id,
                expireDate: notice.expireDate,
            });
        }
        let infoContentsDisplay = this.state.infoContentsDisplay;
        infoContentsDisplay[index] = !this.state.infoContentsDisplay[index];
        this.setState({ 
            notice: notice,
            infoContentsDisplay: infoContentsDisplay,
        });
    }
    createContents() {
        const today = new Date();
        let notice = [];
        let expireDate;
        let infoContentsDisplay = [];
        for (let key in this.state.noticeList) {
            let noticeMarkStyle = { display: "none" };
            if (this.state.noticeList[key].unread) {
                // 未読の場合はマークをつける
                noticeMarkStyle = { color: "red" };
            }
            infoContentsDisplay[key] = false;
            expireDate = new Date(convISO8601(this.state.noticeList[key].expireDate));
            if (expireDate > today) {
                notice.push(
                    <React.Fragment key={key+"fragment"}>
                    <NoticeTitle key={key} onClick={e => this.onClickInfo(e, key)}> 
                        <NoticeDate>{this.state.noticeList[key].createDate}</NoticeDate>
                        <TitleText>
                            {this.state.noticeList[key].title}
                        </TitleText>
                        <InfoRight>
                            <Button key={key+"button"} >
                                {<i className="fas fa-circle fa-xs" style={noticeMarkStyle} />}
                            </Button>
                            {this.state.infoContentsDisplay[key] ? 
                            <img alt="ecprime-logo" src={icon_up} width="30px"  />
                            : <img alt="ecprime-logo" src={icon_down} width="30px"  />}
                        </InfoRight>
                    </NoticeTitle>
                    <NoticeContents key={key+"contents"} Selectable={true} displayNoticeDlg={this.state.infoContentsDisplay[key]}>
                        {getSplitedDivs(this.state.noticeList[key].contents, '\n')} 
                    </NoticeContents>
                    </React.Fragment>
                 )
            }
        }
        return notice;
    }
    onClickHome = () => {
        this.props.history.replace('/home');
    }
    render() {
        const propsScroll = {
            width: '100%',
            height: (window.innerHeight  - 64) + "px",
            contents: this.createContents()
        };
        const propsHeader = {
            current: this.state.current,
            onClickHome: this.onClickHome,
        };
        return (
            <Body>
                <HeaderTitle {...propsHeader}></HeaderTitle>
                <ScrollView ref={this.refScroll}  {...propsScroll} />
            </Body>
        );
    }
}

const mapStateToProps = store => {
    return {
        user: store.login.user,
        loading: store.loading.loading,
    }
};

const connectedNotice = connect(mapStateToProps)(Notice);
export { connectedNotice as Notice };

const Body = styled.div`
`;
const NoticeTitle = styled.div`
    display: grid;    
    width: 98%;
    grid-template-rows: 20px 1fr;
    grid-template-columns: 7px 88% 1fr;
    margin: 5px;
    background-color: #e2f0d9;
    justify-content: center;
`;
const NoticeDate = styled.div`
    grid-row: 1 / 2;
    grid-column: 2 / 3;
    padding: 5px 10px;
    font-size:13px;
    font-weight: normal;
`;
const TitleText = styled.div`
    grid-row: 2 / 3;
    grid-column: 2 / 3;
    padding: 10px 0px;
    font-size:15px;
    font-weight: bold; 
`;
const InfoRight = styled.div`
    grid-row: 1 / 3;
    grid-column: 3 / 4;
    margin: auto 10px auto auto;
    color: #00b050;
    font-size: 25px;
    font-weight: normal;
    position: relative;
`;
const Button = styled.div`
    position: absolute;
    i {
        font-size: 12px;
    }
     top: -60%;
     right: 0px;
`;
const NoticeContents = styled.div`
    width:93%;
    display: ${props => props.displayNoticeDlg ? '':'none'};
    word-break: break-all;
    padding: 5px 10px;
    ${props => props.Selectable ? css`
    css
    -webkit-touch-callout: text; /* iOS Safari */
    -webkit-user-select: text; /* Safari */
    -khtml-user-select: text; /* Konqueror HTML */
    -moz-user-select: text; /* Firefox */
    -ms-user-select: text; /* Internet Explorer/Edge */
    user-select: text; /* Non-prefixed version, currently supported by Chrome and Opera */
    ` : ``};
`;